"use client";

import { Check } from "lucide-react";
import type * as React from "react";
import { Button } from "@/components/ui/button";

export interface TogglePillProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}

export function TogglePill({ value, onChange, label, icon, disabled }: TogglePillProps) {
  return (
    <Button
      type="button"
      // `outline`, not `ghost`: the selected state has always asked for
      // `border-primary`, and a ghost button has no border width for it to
      // colour, so that style never rendered.
      variant="outline"
      size="sm"
      className={
        value
          ? "h-7 gap-1.5 rounded-full border-primary bg-accent px-2 text-xs font-normal text-accent-foreground hover:border-primary hover:bg-accent/80"
          : "h-7 gap-1.5 rounded-full px-2 text-xs font-normal text-muted-foreground hover:text-foreground"
      }
      onClick={() => onChange(!value)}
      disabled={disabled}
    >
      {/* Nothing when unselected: the outline already marks the pill as a
          choice, and an X on every unpicked option reads as a row of refusals. */}
      {icon ?? (value ? <Check className="size-3 text-emerald-500" /> : null)}
      <span>{label}</span>
    </Button>
  );
}
